<div class="ti-page">

  <!-- ── Page header ──────────────────────────────────────────── -->
  <div class="ti-header">
    <div class="ti-header__left">
      <div class="ti-header__icon">
        <mat-icon>timer</mat-icon>
      </div>
      <div>
        <h1 class="ti-header__title">Registro de horas</h1>
        <p class="ti-header__sub">Consulta y valida los registros de tiempo del equipo</p>
      </div>
      <app-tutorial-button tutorial="personal-horas-turnos"></app-tutorial-button>
    </div>
    <div class="ti-header__right">
      <button mat-stroked-button type="button" (click)="toggleVistaEmpresa()">
        <mat-icon>{{ mostrarEmpresa ? 'person' : 'groups' }}</mat-icon>
        {{ mostrarEmpresa ? 'Ver por empleado' : 'Ver toda la empresa' }}
      </button>
    </div>
  </div>

  <!-- ── Vista agregada de empresa ───────────────────────────────── -->
  <ng-container *ngIf="mostrarEmpresa">
    <div class="ti-filter-card">
      <div class="ti-filter-card__head">
        <mat-icon class="ti-filter-card__icon">groups</mat-icon>
        <span class="ti-filter-card__label">Fichajes de todos los empleados</span>
      </div>
      <form [formGroup]="formRangoEmpresa" (ngSubmit)="buscarRegistrosEmpresa()" class="ti-filter-form">
        <mat-form-field appearance="outline" class="ti-filter-field">
          <mat-label>Fecha inicio</mat-label>
          <input matInput [matDatepicker]="pickerInicioEmpresa" formControlName="fechaInicio">
          <mat-datepicker-toggle matSuffix [for]="pickerInicioEmpresa"></mat-datepicker-toggle>
          <mat-datepicker #pickerInicioEmpresa></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="ti-filter-field">
          <mat-label>Fecha fin</mat-label>
          <input matInput [matDatepicker]="pickerFinEmpresa" formControlName="fechaFin">
          <mat-datepicker-toggle matSuffix [for]="pickerFinEmpresa"></mat-datepicker-toggle>
          <mat-datepicker #pickerFinEmpresa></mat-datepicker>
        </mat-form-field>

        <div class="ti-filter-actions">
          <button mat-flat-button class="ti-btn-primary" type="submit" [disabled]="!formRangoEmpresa.valid">
            <mat-icon>search</mat-icon> Buscar
          </button>
        </div>
      </form>

      <div class="ti-filter-actions" *ngIf="registrosEmpresaCargados">
        <button mat-stroked-button type="button" (click)="exportarEmpresaExcel()">Exportar a Excel</button>
        <button mat-stroked-button type="button" (click)="exportarEmpresaPdf()">Exportar a PDF</button>
        <button mat-stroked-button type="button" (click)="exportarEmpresaCsv()">Exportar a CSV</button>
      </div>
    </div>

    <div class="ti-results" *ngIf="registrosEmpresaCargados">
      <div class="ti-loading ti-loading--inline" *ngIf="(registroHorasService.loading$ | async)">
        <div class="ti-loading__dots"><span></span><span></span><span></span></div>
        <p class="ti-loading__text">Cargando…</p>
      </div>

      <table mat-table [dataSource]="registrosEmpresa" *ngIf="registrosEmpresa.length > 0">
        <ng-container matColumnDef="empleado">
          <th mat-header-cell *matHeaderCellDef>Empleado</th>
          <td mat-cell *matCellDef="let registro">{{ nombreEmpleado(registro.employeesId) }}</td>
        </ng-container>

        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let registro">{{ registro.fecha | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="entrada">
          <th mat-header-cell *matHeaderCellDef>Entrada</th>
          <td mat-cell *matCellDef="let registro">{{ registro.horaEntrada | date:'HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="salida">
          <th mat-header-cell *matHeaderCellDef>Salida</th>
          <td mat-cell *matCellDef="let registro">{{ registro.horaSalida | date:'HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let registro">
            <mat-chip-listbox>
              <mat-chip-option [color]="registro.estado === 2 ? 'primary' : 'warn'" selected>
                {{ registro.cadenaEstado }}
              </mat-chip-option>
            </mat-chip-listbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let registro">
            <button mat-icon-button [matMenuTriggerFor]="empresaMenu" [matMenuTriggerData]="{registro: registro}">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['empleado', 'fecha', 'entrada', 'salida', 'estado', 'acciones']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['empleado', 'fecha', 'entrada', 'salida', 'estado', 'acciones'];"></tr>
      </table>

      <div class="ti-empty" *ngIf="registrosEmpresa.length === 0">
        <div class="ti-empty__art"><mat-icon>event_busy</mat-icon></div>
        <h3 class="ti-empty__title">Sin registros</h3>
      </div>
    </div>

    <mat-menu #empresaMenu="matMenu">
      <ng-template matMenuContent let-registro="registro">
        <button mat-menu-item (click)="validarRegistroEmpresa(registro)" *ngIf="registro.estado === 8">
          <mat-icon>check_circle</mat-icon>
          <span>Validar</span>
        </button>
        <button mat-menu-item (click)="rechazarRegistroEmpresa(registro)" *ngIf="registro.estado === 8">
          <mat-icon>cancel</mat-icon>
          <span>Rechazar</span>
        </button>
        <button mat-menu-item (click)="editarRegistroEmpresa(registro)">
          <mat-icon>edit</mat-icon>
          <span>Editar</span>
        </button>
        <button mat-menu-item (click)="verHistorialEmpresa(registro)">
          <mat-icon>history</mat-icon>
          <span>Ver historial</span>
        </button>
      </ng-template>
    </mat-menu>
  </ng-container>

  <!-- ── Loading ──────────────────────────────────────────────── -->
  <div class="ti-loading" *ngIf="(loading$ | async)">
    <div class="ti-loading__icon-wrap"><mat-icon>timer</mat-icon></div>
    <div class="ti-loading__dots"><span></span><span></span><span></span></div>
    <p class="ti-loading__text">Cargando…</p>
  </div>

  <ng-container *ngIf="!(loading$ | async) && !mostrarEmpresa">

    <!-- ── Sin empleados ───────────────────────────────────────── -->
    <div class="ti-empty" *ngIf="empleados == null || empleados.length === 0">
      <div class="ti-empty__art">
        <mat-icon>people_outline</mat-icon>
      </div>
      <h3 class="ti-empty__title">Sin empleados disponibles</h3>
      <p class="ti-empty__sub">
        Para consultar registros de tiempo es necesario tener empleados registrados en el sistema.
      </p>
    </div>

    <!-- ── Contenido principal ─────────────────────────────────── -->
    <ng-container *ngIf="empleados != null && empleados.length > 0">

      <!-- Filtro de búsqueda -->
      <div class="ti-filter-card" *ngIf="formBusqueda !== null">
        <div class="ti-filter-card__head">
          <mat-icon class="ti-filter-card__icon">search</mat-icon>
          <span class="ti-filter-card__label">Buscar registros por empleado</span>
        </div>
        <form [formGroup]="formBusqueda" (ngSubmit)="obtenerRegistrosPorEmpleado()" class="ti-filter-form">
          <mat-form-field appearance="outline" class="ti-filter-field">
            <mat-label>Empleado</mat-label>
            <mat-select formControlName="empleado">
              <mat-option *ngFor="let e of empleados; trackBy: trackByIndex" [value]="e.uid">
                {{ e.name }}
              </mat-option>
            </mat-select>
            <mat-hint>Selecciona el empleado para buscar sus registros</mat-hint>
            <mat-error *ngIf="formBusqueda.controls['empleado'].hasError('required')">
              El empleado es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>

          <div class="ti-filter-actions">
            <button mat-flat-button class="ti-btn-primary" type="submit">
              <mat-icon>search</mat-icon> Buscar
            </button>
            <button mat-stroked-button class="ti-btn-ghost" type="button" (click)="cancelar()"
                    *ngIf="registrosCargados">
              <mat-icon>close</mat-icon> Limpiar
            </button>
          </div>
        </form>
      </div>

      <!-- Resultados -->
      <div class="ti-results" *ngIf="registrosCargados">

        <!-- Loading inline -->
        <div class="ti-loading ti-loading--inline" *ngIf="(registroHorasService.loading$ | async)">
          <div class="ti-loading__dots"><span></span><span></span><span></span></div>
          <p class="ti-loading__text">Cargando registros…</p>
        </div>

        <ng-container *ngIf="!(registroHorasService.loading$ | async)">
          <div class="ti-results__head">
            <mat-icon class="ti-results__icon">history</mat-icon>
            <span class="ti-results__label">
              Registros de <strong>{{ nombreEmpleado(formBusqueda.get('empleado').value) }}</strong>
            </span>
          </div>

          <div class="ti-groups"
               *ngIf="registrosHoy.length > 0 || registrosSemanaActual.length > 0 || registrosMesActual.length > 0 || registrosMesPasado.length > 0">
            <app-grupo-registros-tiempo
              [titulo]="'Hoy'"
              [registros]="registrosHoy"
              [empleado]="formBusqueda.get('empleado').value"
              (actualizarRegistros)="actualizarRegistros($event)">
            </app-grupo-registros-tiempo>

            <app-grupo-registros-tiempo
              [titulo]="'Esta semana'"
              [registros]="registrosSemanaActual"
              [empleado]="formBusqueda.get('empleado').value"
              (actualizarRegistros)="actualizarRegistros($event)">
            </app-grupo-registros-tiempo>

            <app-grupo-registros-tiempo
              [titulo]="'Este mes'"
              [registros]="registrosMesActual"
              [empleado]="formBusqueda.get('empleado').value"
              (actualizarRegistros)="actualizarRegistros($event)">
            </app-grupo-registros-tiempo>

            <app-grupo-registros-tiempo
              [titulo]="'Mes pasado'"
              [registros]="registrosMesPasado"
              [empleado]="formBusqueda.get('empleado').value"
              (actualizarRegistros)="actualizarRegistros($event)">
            </app-grupo-registros-tiempo>
          </div>

          <app-grupo-registros-tiempo
            [titulo]="'Rango de fechas'"
            [registros]="registrosRangoFechas"
            [empleado]="formBusqueda.get('empleado').value"
            [formulario]="true"
            (actualizarRegistros)="actualizarRegistros($event)">
          </app-grupo-registros-tiempo>
        </ng-container>

      </div>

    </ng-container>

  </ng-container>

</div>
